// extracted by mini-css-extract-plugin
module.exports = {"mds-popover":"mds-popover__dap-crawler"};